import React from 'react';
import {
  Body1,
  tokens,
  Subtitle1,
  makeStyles,
  mergeClasses,
} from '@fluentui/react-components';
import { EntryCardSVGIcons } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

const WarningDialogueContent = ({ i18n }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <img
        src={EntryCardSVGIcons.WarningSVGIcon}
        alt={i18n.getString(_TL_('Creating a new brand kit will delete the old kit from the Ad Studio'))}
      />
      <div>
        <Subtitle1 className={mergeClasses('warning-title', classes.title)} block>
          {i18n.getString(_TL_('Creating a new brand kit will delete the old kit from the Ad Studio'))}
        </Subtitle1>
        <Body1
          color={tokens.colorNeutralStroke1}
          className={mergeClasses('warning-description', classes.description)}
        >
          {i18n.getString(_TL_('You can only create and save one brand kit in Ad Studio'))}
        </Body1>
      </div>
    </div>
  );
};

export { WarningDialogueContent };
